<style>
.workflow-accordion-conautomation_template_editortainer-modify-record {
  padding: 0px 10px 10px 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.popup-container-main {
  z-index: 999 !important;
}

.addCheck {
    background-color: aliceblue;
}
</style>
<template>
  <div class="accordion" id="accordionAutomation-create">

    <div class="card"
         v-if="(this.mapping_for.name != 'visibility' && filterFieldValue()) || this.mapping_for.field_type == 'relationship'">
      <div class="card-header automation-card-header" id="headingOne">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            {{ table }}
          </button>
        </p>
      </div>
      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
           data-parent="#accordionAutomation-create">
        <div class="card-body">
          <div class="workflow-row-details">
            <ul>
              <li v-if="filterField(field_type, field)" v-for="field in fieldsData()" @click="SelectName(field, 'new')">
                <a v-bind:class="{ active: CheckItemSelected(field, 'new') }" href="javascript:void(0)">{{
                    field.label
                  }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card"
         v-if="(this.mapping_for.name != 'visibility' && filterFieldValue() && executeHandler != 1 && executeHandler != 2) || this.mapping_for.field_type == 'relationship' && executeHandler != 1 && executeHandler != 2">
      <div class="card-header automation-card-header" id="headingOldRecord">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseOldRecord" aria-expanded="false" aria-controls="collapseOldRecord">
            {{ table }} {{ lang.old }} {{ lang.record }}
          </button>
        </p>
      </div>
      <div id="collapseOldRecord" class="collapse" aria-labelledby="headingOldRecord"
           data-parent="#accordionAutomation-create">
        <div class="card-body">
          <div class="workflow-row-details">
            <ul>
              <li v-if="filterField(field_type, field)" v-for="field in fieldsData()" @click="SelectName(field, 'old')">
                <a v-bind:class="{ active: CheckItemSelected(field, 'old') }"
                   href="javascript:void(0)">{{ lang.old }}{{ lang.record }}.{{ field.label }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="checkFieldName() && this.mapping_for.name != 'visibility' && filterFieldValue()">
      <div class="card-header automation-card-header" id="headingUserRelated">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseUserRelated" aria-expanded="true" aria-controls="collapseUserRelated">
            {{ lang.users }}
          </button>
        </p>
      </div>
      <div id="collapseUserRelated" class="collapse" aria-labelledby="headingUserRelated"
           data-parent="#accordionAutomation-create">
        <div class="card-body">
          <div class="workflow-row-details">
            <ul>
              <li v-for="user in users.user_name" v-if="checkNull(user)" @click="SelectName(user, 'user')"><a
                  v-bind:class="{ addCheck: CheckItemSelected(user, 'user') }" href="javascript:void(0)">{{
                  user.name
                }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="custom">
      <div class="card-header automation-card-header" id="headingCustom">
        <p class="mb-0 automation-accordion-p">
          <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                  data-target="#collapseCustom-create" aria-expanded="false" aria-controls="collapseCustom-create">
            {{ lang.custom }}
          </button>
        </p>
      </div>
      <div id="collapseCustom-create" class="collapse" aria-labelledby="headingCustom"
           data-parent="#accordionAutomation-create">
        <div class="card-body" v-if="this.mapping_for.name != 'visibility' && filterFieldValue()">
          <div id="filterSearch" class="workflow-row-details">
            <input type="text"
                   v-model="getCustomInput"
                   class="form-control custom-input-value"
                   :placeholder="lang.enter+' '+lang.value.toLowerCase()"
                   name="custom_text">
            <button
                class="btn btn-outline-primary btn-apply-condition"
                autofocus="on"
                v-if="custom"
                v-on:click.stop.prevent="inputCustomValue()">
              {{ lang.apply }}
            </button>
          </div>
        </div>

        <div class="card-body" v-else>
          <div class="workflow-row-details" v-if="filterFieldValue()">
            <ul>
              <li v-for="(visibility,index) in visibilities"
                  @click="inputCustomValue({'value' : visibility, 'id' : index }, 'custom')">
                <a v-bind:class="{ active: CheckItemSelected({'value' : visibility, 'id' : index }, 'custom') }"
                   href="javascript:void(0)">
                  {{ visibility }}
                </a>
              </li>
            </ul>
          </div>
          <div class="workflow-row-details" v-else>
            <ul>
              <li v-for="(default_value,index) in getSelectedFiledValue()"
                  @click="inputCustomValue({ 'value' : default_value, 'id' : index }, 'custom', true)"><a
                  v-bind:class="{ active: CheckItemSelected({ 'value' : default_value, 'id' : index }, 'custom') }"
                  href="javascript:void(0)">{{ default_value }}</a></li>
            </ul>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>
<script>
export default {
  props: [
    'fields', //selected table fields
    'table', // selected table name
    'level', // advanced condition level
    'mapping_for',
    'field_type',
    'custom',
    'CreateRecordMapping',
    'users',
    'executeHandler',
    'lang',
    'SelectedTableExcludedColumnList',
  ],
  data() {
    return {
      customvalueSet: null,
      userRelatedField: [
        'created_by',
        'modified_by',
        'assigned_to',
        'multi_assigned_to',
      ],
      visibilities: {
        1: 'Everyone',
        0: 'Private',
      },
      fieldType: [
        'select',
        'multiselect',
        'multipleselect',
        'radio',
        'checkbox',
        'relationship'
      ],
      selectCheckFieldNames: [
        'visibility',
        'multi_assigned_to',
      ],
    }
  },
  mounted() {

  },
  computed: {
    getCustomInput: {
      get() {
        return this.hasInputValue();
      },
      set(newVal) {
        this.customvalueSet = newVal;
        return newVal;
      }
    }
  },
  created() {
    // console.log(this.fieldType);
  },
  methods: {
    filterFieldValue() {
      if (this.fieldType.includes(this.mapping_for.field_type)) {
        return false;
      }
      return true;
    },
    getSelectedFiledValue() {
      if (this.field_type == 'checkbox' && !this.mapping_for.select_values) {
        this.mapping_for.select_values = [
          'on',
          'off'
        ];
      } else if (this.field_type == 'relationship') {
        this.mapping_for.select_values = this.mapping_for.related_fields;
      }
      return this.mapping_for.select_values;
    },
    fieldsData() {
      if (this.mapping_for.field_type == 'relationship') {
        return this.SelectedTableExcludedColumnList;
      }

      if (this.mapping_for.name == 'assigned_to') {
        return this.SelectedTableExcludedColumnList;
      }

      return this.fields;
    },
    SelectName(field, record_type) {
      let data = {
        mapping_for: this.mapping_for,
        selected_field: field,
        record_type: record_type,
      };

      if (record_type === 'user' && this.mapping_for.name === 'multi_assigned_to') {
        data['selected_field']['field_type_dd'] = 'multiselect'
      } else if (this.mapping_for.field_type == 'relationship') {
        if (data['selected_field'] != undefined) {
          data['selected_field']['field_type_dd'] = 'relationship';
        }
      } else {
        data['selected_field']['field_type_dd'] = null;
      }

      this.$emit('CreateRecordOptionSelectedEvent', data);
    },
    CheckItemSelected(field, record_type) {

      let _index = this.CreateRecordMapping.findIndex(x => x.record_type == record_type && x.mapped_with_id == field.id && x.mapping_for_id == this.mapping_for.id);

      if (this.fieldType.includes(this.mapping_for.field_type) || this.selectCheckFieldNames.includes(this.mapping_for.name)) {

        let _inner_index = null;
        let outer_index = this.CreateRecordMapping.findIndex(x => x.mapping_for_id == this.mapping_for.id && x.record_type == record_type);

        if (outer_index > -1) {
          if (this.CreateRecordMapping[outer_index].record_type == 'old') {
            _inner_index = _index;
          } else {
            _inner_index = this.CreateRecordMapping[outer_index].mapped_with_id.toString().indexOf(field.id);
          }
        }
        _index = _inner_index;
      }

      if (_index != null && _index > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasInputValue() {
      let customValue = null;
      let _index = this.CreateRecordMapping.findIndex(x => x.record_type == 'custom' && x.mapping_for_id == this.mapping_for.id);

      if (_index > -1) {
        customValue = this.CreateRecordMapping[_index].mapped_with_name;
      }
      return customValue;
    },
    inputCustomValue(field = null, record_type = null, related = false) {

      let data = {
        'mapping_for': null,
        'selected_field': null,
        'record_type': 'custom',
      };

      if (field && field != null && record_type != null) {
        if (related) { // related table data 'type = relationship' or select values has In field table
          data['mapping_for'] = this.mapping_for;
          data['selected_field'] = {
            'name': field.value,
            'label': field.value,
            'field_type_dd': this.field_type,
            'id': field.id,
          };

        } else {
          data['mapping_for'] = this.mapping_for;
          data['selected_field'] = {
            'name': field.value,
            'label': field.value,
            'field_type_dd': this.field_type,
            'id': field.id,
          };
        }
      } else {
        data['mapping_for'] = this.mapping_for;
        data['selected_field'] = {
          'name': this.customvalueSet,
          'label': this.customvalueSet,
          'id': null,
          'field_type_dd': this.field_type,
        };
      }

      this.$emit('CreateRecordOptionSelectedEvent', data);
    },
    outside() {
      this.$emit('OutsideClickEvent');
    },
    filterField(field_type, field) {
      if (field_type == 'date' && field_type == field.field_type) {
        return true;
      }
      if (field_type == 'email' && field_type == field.field_type) {
        return true;
      }
      if (field_type != 'date' && field_type != 'email') {
        return true;
      }
    },
    checkFieldName() {
      let isIncludeSelctedField = this.userRelatedField.includes(this.mapping_for.name);

      if (isIncludeSelctedField) {
        return true;
      }

      return false;
    },
    checkNull(user) {
      if (!user.name) {
        return false;
      }
      return true;
    }
  }
}
</script>
